const formatToYen = (amount?: number) => {
  if (amount == undefined || amount === null || Number.isNaN(amount)) return ''

  return `¥ ${amount.toLocaleString('jp-JP')}`
}

export default formatToYen
